import React from "react";
import { cn } from "~/utils";

const TextArea = React.forwardRef(function (
  {
    className = "",
    containerClassName = "",
    invalid = false,
    invalidClassName = "",
    label = "",
    labelClassName = "",
    ...props
  },
  ref,
) {
  const id = `${label ? label.toLowerCase() : "unlabelled"}-textarea`;
  return (
    <div className={cn("flex flex-1 flex-col gap-1", containerClassName)}>
      {label && (
        <label
          htmlFor={id}
          className={cn(
            "text-xs text-slate-500",
            labelClassName,
            invalid ? cn("text-red-400", invalidClassName) : "",
          )}
        >
          {label}
        </label>
      )}
      <textarea
        id={id}
        ref={ref}
        className={cn(
          "h-full w-full resize-y rounded border border-gray-200 !p-[7px] font-['Trebuchet_MS'] text-sm outline-blue-300",
          className,
          invalid ? "border-red-400 outline-red-400" : "",
        )}
        {...props}
      />
    </div>
  );
});

export default TextArea;
